/**
 * @documental
 * @export Badge
 * @import
 * import { Badge } from "capitalrx-components-2.0/lib/general";
 */

import { FC, ReactNode } from "react";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Tag, TagProps } from "../Tag";
import { Button, ButtonClickEventHandler } from "../Button";
import classNames from "classnames";
import styles from "./styles.module.scss";

/**
 * The `Badge` component properties.
 */
export interface BadgeProps extends TagProps {
  /**
   * Called when the close button is clicked.
   */
  readonly onClick?: ButtonClickEventHandler;

  /**
   * Indicates whether the badge is disabled.
   */
  readonly disabled?: boolean;

  /**
   * The badge tooltip.
   */
  readonly tooltip?: ReactNode;

  /**
   * The close button tooltip.
   */
  readonly buttonTooltip?: ReactNode;
}

/**
 * A badge.
 */
export const Badge: FC<BadgeProps> = (props) => {
  const { children, tooltip, buttonTooltip, onClick, disabled = false } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.Badge, "badge"],
    testIdPrefix: "badge",
  });

  return (
    <Tag
      {...props}
      {...getBasePropsFromHtmlProps(baseHtmlProps)}
      tooltip={tooltip}
      aria-live={disabled ? undefined : "polite"}
      aria-disabled={disabled}
    >
      <Shelf
        className={classNames({
          [styles.Shelf]: !disabled,
        })}
        spacing="mini"
      >
        <span className={classNames(styles.Content, "content")}>{children}</span>
        {!disabled && (
          // TODO: add key handlers to buttons
          <Button
            className={styles.CloseButton}
            appearance="text"
            icon="x"
            size="small"
            tooltip={buttonTooltip}
            onClick={onClick}
            aria-label="Close Badge"
          />
        )}
      </Shelf>
    </Tag>
  );
};
